import type { CSSProperties } from "react";
import { cn } from "@/lib/cn";

/** Loading placeholder. Match the shape of the content it replaces (skeletons, not spinners). */
export function Skeleton({ className, style, rounded = "item" }: { className?: string; style?: CSSProperties; rounded?: "item" | "pill" | "full" | "card" }) {
  return (
    <div
      aria-hidden
      style={style}
      className={cn(
        "skeleton-shimmer animate-shimmer",
        rounded === "pill" ? "rounded-pill" : rounded === "full" ? "rounded-full" : rounded === "card" ? "rounded-card" : "rounded-item",
        className,
      )}
    />
  );
}

/** A few lines of text-shaped skeletons. */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn("grid gap-2", className)} role="status" aria-label="Loading">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className="h-3.5" style={{ width: i === lines - 1 ? "62%" : `${92 - i * 6}%` }} />
      ))}
    </div>
  );
}
